import { gql } from "@apollo/client";

export const CHECK_DEPOSIT = gql`
query CheckDeposits {
    checkDeposits {
        status
    }
}
`;
